/* Crisis Bunker · El Niño landing behaviour.
   Loaded once, safe to reference from every section. */
(function () {
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.eln .reveal').forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = window.__elnIO || (window.__elnIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); window.__elnIO.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }));
    document.querySelectorAll('.eln .reveal:not(.eln-obs)').forEach(function (el) {
      el.classList.add('eln-obs');
      io.observe(el);
    });
  }

  function initCapture() {
    document.querySelectorAll('.eln .capture:not(.eln-bound)').forEach(function (form) {
      form.classList.add('eln-bound');
      var btn = form.querySelector('[data-cap-btn]');
      var input = form.querySelector('[data-cap-email]');
      var msg = form.querySelector('[data-cap-msg]');
      if (!btn || !input || !msg) return;
      btn.addEventListener('click', function () {
        var email = (input.value || '').trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!ok) { msg.style.color = '#fff'; msg.textContent = "Pop in a valid email and we'll send it over."; return; }
        /* TODO: replace this stub with your Klaviyo list-subscribe call or embedded form submit. */
        msg.style.color = 'var(--eln-yellow)';
        msg.textContent = "Ka pai, it's on its way. Check your inbox.";
        input.value = '';
      });
    });
  }

  function run() { initReveal(); initCapture(); }

  if (document.readyState !== 'loading') { run(); }
  else { document.addEventListener('DOMContentLoaded', run); }

  /* Re-run when a section is added or edited in the theme customiser. */
  document.addEventListener('shopify:section:load', run);
})();
